import { render, staticRenderFns } from "./msComboboxMultipleV2.vue?vue&type=template&id=0c2ba7d5&scoped=true"
import script from "./msComboboxMultipleV2.vue?vue&type=script&lang=js"
export * from "./msComboboxMultipleV2.vue?vue&type=script&lang=js"
import style0 from "./msComboboxMultipleV2.vue?vue&type=style&index=0&id=0c2ba7d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ba7d5",
  null
  
)

export default component.exports